<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { translate } from '~/composables/translate/translations'
import { useOfferStore } from '~/stores/offer'
import { useStepStore } from '~/stores/step'
import { type StepPath, STEPS_RECORD } from '~/stores/steps-definition'

const props = defineProps<{ name: StepPath }>()

const stepStore = useStepStore()
const { selectedOffer, blurNotSelectedVehicles } = storeToRefs(useOfferStore())

const isCurrent = computed<boolean>(() => stepStore.currentStepPath === props.name)

function getStepStatusClass(): string {
  if (isCurrent.value)
    return 'current'
  else if (stepStore.stepsStarted[props.name])
    return 'done'
  else
    return 'next'
}

function scrollToSelectedVehicle() {
  setTimeout(() => {
    const { value: selectedOfferValue } = selectedOffer
    const buildSeries = selectedOfferValue?.buildSeries
    if (!buildSeries)
      return
    const position: ScrollLogicalPosition = screen.width <= 640 ? 'start' : 'center'
    document.getElementById(buildSeries)?.scrollIntoView({ block: position })
  }, 50)
}

function navigate() {
  stepStore.goToStep(props.name)
  if (props.name === 'category') {
    blurNotSelectedVehicles.value = false
    scrollToSelectedVehicle()
  }
}
</script>

<template>
  <button
    :class="[getStepStatusClass(), name === 'personal' ? 'snap-end shrink-0 pr-24 h-full -mt-8' : '']" class="text-xs my-auto"
    :data-testid="`breadcrumb-button_${props.name}`"
    @click="navigate()"
  >
    <span :class="isCurrent ? 'text-black-100' : 'text-black-60'"> {{ translate(STEPS_RECORD[props.name].translationKey) }}</span>
  </button>
</template>

<style lang="scss" scoped>
@import "tailwindcss" reference;
@import "@camelot/tailwind-config/themes/camelot.css" reference;

.current {
  @apply rounded-xl bg-rebel-20 py-4 px-8 font-bold text-pitch
}

.done {
  @apply text-pitch font-bold
}

.next {
  @apply text-black-40
}
</style>
